import React from "react";

function Restauration() {
  return (
    <div className="restauration">
      <div className="paddingTopMobile"></div>

      <h1>Restauration</h1>
      <div className="restaurationContent">
        <div className="cardRestaurationContainer">
          <h2 className="title">Le petit déjeuner </h2>
          <div className="cardTextAndImageContainer">
            {/* <img src={img1} className="cardImageRestauration imagePetitDejeunerRestauration"></img> */}
            <p>
              Petit-déjeuner continental : salade de fruits frais, dont certains viennent de la propriété selon la saison (litchis, mangues, pitayas…), pain et viennoiseries de l’Atelier Gourmand cuits le matin, confitures locales et jus de fruits.
            </p>
            <div className="cardImageRestauration imagePetitDejeunerRestauration"></div>
          </div>
          <p className="cardTarifRestauration">
            Tarifs : 1580 XPF / 980 XPF pour les enfants de moins de 6 ans. br
            Œufs en suppléments : 500/600 XPF
          </p>
        </div>

        <div className="cardRestaurationContainer">
          <h2 className="title">Le déjeuner </h2>
          <div className="cardTextAndImageContainer dejeuner">
            <p>
              Sur demande, 24 h à l’avance, servi de 11h30 à 13h. Nous vous proposons nos bruschettas gourmandes : saumon frais et crème de ciboulette, jambon serrano et parmesan, chèvre et tomates séchées, confit de canard gratiné, wahoo fumé… Deux bruschettas au choix, servies avec une salade verte, des chips de bacon et un œuf poché.
            </p>
            <div className="cardImageRestauration imageDejeunerRestauration"></div>
          </div>
          <div className="cardTarifRestauration">
            <p> Tarifs : 2450 XPF</p>
          </div>
        </div>

        <div className="cardRestaurationContainer">
          <h2 className="title">Le diner </h2>
          <div className="cardTextAndImageContainer diner">
            <div className="cardImageRestauration imageDinerRestauration"></div>
            <p>
              Sur réservation, servi à 19h et ouvert à la clientèle extérieure. L’entrée est unique, le plat principal se choisit entre une proposition viande et une proposition poisson, et le dessert est au choix. Vous pouvez opter pour 2 ou 3 plats. Un régime particulier ? Prévenez-nous, nous trouverons toujours une solution.
              La cuisine marie les influences calédoniennes, des plats typiquement « frenchies » aux préparations locales. Nous privilégions les circuits courts : notre viande vient essentiellement des deux bouchers-éleveurs du village, nos salades, herbes et certains légumes de notre voisin. Notre fournisseur de poisson vous fera goûter le mahi-mahi, le thon jaune ou le wahoo, sans parler de nos crevettes locales !
            </p>
          </div>
          <br />
          <div className="cardTarifRestauration">
            <p>
              {" "}
              Tarifs : 2 plats 3550 XPF - 3 plats 4150 XPF - menu enfant 1680
              XPF
            </p>
            <p> Carte de vins et alcools</p>
          </div>
        </div>

        <div className="cardRestaurationContainer">
          <h2 className="title">Le lieu</h2>
          <div className="cardTextAndImageContainer diner">
            <div className="cardImageRestauration imageLieu2Restauration"></div>
            <p>
              La salle de restauration s’ouvre sur la piscine et le parc, avec un bar à votre disposition. Un lieu de convivialité, à l’image du nom de Betikure, qui signifie « partager la marmite » dans une langue locale.
            </p>
              <div className="cardImageRestauration imageLieuRestauration"></div>
          </div>
        </div>

        <div className="cardRestaurationContainer">
          <h2 className="title">Le Faré</h2>
          <div className="cardTextAndImageContainer">
            <p>
              Envie de griller vous-même ? Nous mettons gratuitement à votre disposition un vaste faré avec une belle vue sur la vallée, équipé de 2 planchas au gaz et de 2 grandes tables à partager. Il suffit de le réserver à la réception.
            </p>

            <div className="cardImageRestauration imageFareRestauration"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Restauration;
